module.exports =  {
  MAIN_PAGE: "MAIN_PAGE",
  ADD_MEMBERS: "ADD_MEMBERS",
  PAYMENT: "PAYMENT",
  MEMBER_DETAIL: "MEMBER_DETAIL",
  MEMBER_DELETE: "MEMBER_DELETE",
  PLAN_AND_BILLING: "PLAN_AND_BILLING",
  // Pause/Cancel flow pages
  PAUSE_FEEDBACK_SURVEY: "PAUSE_FEEDBACK_SURVEY",
  PAUSE_FEEDBACK_DETAIL: "PAUSE_FEEDBACK_DETAIL",
  PAUSE_FEEDBACK_HELP: "PAUSE_FEEDBACK_HELP",
  PAUSE_FEEDBACK_CONFIRM: "PAUSE_FEEDBACK_CONFIRM",
  CANCEL_SUBSCRIPTION: "CANCEL_SUBSCRIPTION",
  UNCANCEL_SUBSCRIPTION: "UNCANCEL_SUBSCRIPTION",
  ANNUAL_SUBSCRIPTION: "ANNUAL_SUBSCRIPTION",
  SUBSCRIPTION_PAST_DUE: "SUBSCRIPTION_PAST_DUE",
  BLOCKER: "BLOCKER",
  PROJECT_BLOCKER: "PROJECT_BLOCKER"
}
